import { atom } from "jotai";

// Authentication State Atoms
export const resetTokenAtom = atom(
  new URLSearchParams(window.location.search).get("rt")
);
export const isRegisteringAtom = atom(false);
export const isRecoveringAtom = atom(false);
export const isSettingNewPasswordAtom = atom(false);
export const passwordAtom = atom("");
export const firstNameAtom = atom("");
export const lastNameAtom = atom("");
export const errorAtom = atom("");
export const successMessageAtom = atom("");
export const referrerAtom = atom(null);
